export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  loading = false,
  variant = "default",
  onCancel,
  onConfirm,
}) {
  if (!open) return null;

  const confirmClass =
    variant === "danger"
      ? "primary-page-btn modal-btn-danger"
      : "primary-page-btn";

  return (
    <div
      className="confirm-dialog-overlay"
      role="presentation"
      onClick={loading ? undefined : onCancel}
    >
      <div
        className="modal-box confirm-dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-message"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="confirm-dialog-title">{title}</h3>
        <div id="confirm-dialog-message" className="confirm-dialog__message">
          {message}
        </div>
        <div className="modal-actions confirm-dialog__actions">
          <button
            type="button"
            className="secondary-page-btn"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={confirmClass}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Please wait…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
